import React from 'react';

class LoadingIcon extends React.PureComponent {
    render() {
        let classNameList = ['loading-icon'];

        if(this.props.className) {
            classNameList = classNameList.concat(this.props.className.split(' '));
        }

        return (
            <i className={ classNameList.join(' ') }>
        		<span className="one"></span>
        		<span className="two"></span>
        		<span className="three"></span>
        		<span className="four"></span>
        		<span className="five"></span>
        		<span className="six"></span>
        		<span className="seven"></span>
        		<span className="eight"></span>
        		<span className="nine"></span>
        		<span className="teen"></span>
        	</i>
        );
    }
}

export default LoadingIcon;
